export default __webpack_public_path__ + "static/media/logo-bdstrading-white.5b8bac39.svg";